import {API_ERROR, API_INFO, API_OAUTH_IN_PROGRESS, API_SUCCESS, API_WARNING} from "../actions/types";

const parseBaseApiResult = (action, success, state) => ({
    requestId: action.actionId,
    message: (action.payload && action.payload.message) || action.message,
    success: success,
    state: state
});

export default function (state = {}, action) {
    switch (action.type) {
        case API_INFO:
            return ({
                ...state,
                requestResult: parseBaseApiResult(action, true, "info")
            });
        case API_SUCCESS:
            return ({
                ...state,
                requestResult: parseBaseApiResult(action, true, "success")
            });
        case API_WARNING:
            return ({
                ...state,
                requestResult: parseBaseApiResult(action, true, "warning")
            });
        case API_ERROR:
            if (action.payload.group) {
                switch (action.payload.group) {

                }

                return ({
                    ...state,
                    requestResult: {
                        ...parseBaseApiResult(action, false, "error"),
                        group: action.payload.group
                    }
                });
            }
            return ({
                ...state,
                requestResult: parseBaseApiResult(action, false, "error")
            });
        case API_OAUTH_IN_PROGRESS:
            return ({
                ...state,
                oauthInProgress: action.payload
            });
    }

    return ({
        ...state,
        requestResult: {
            requestId: undefined,
            success: false,
            message: undefined
        }
    });
}
